/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyQuestionList = {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestion',
    },
};